import { render } from "./NewEvent.vue?vue&type=template&id=51b56642"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"
script.render = render

export default script